// The board is a classroom panel students can read, so account identifiers are masked by default.
// Import-free so it loads under node --test.

const HIDDEN = '***';

function keep(text: string): number {
  return text.length <= 2 ? 1 : 2;
}

/** `admin@izteach.vn` -> `ad***@izteach.vn` */
export function maskEmail(email: string): string {
  const value = email.trim();
  const at = value.lastIndexOf('@');
  if (at <= 0 || at === value.length - 1) return maskText(value);
  const local = value.slice(0, at);
  return `${local.slice(0, keep(local))}${HIDDEN}${value.slice(at)}`;
}

/** `0912345696` -> `09******96`: first two and last two digits, a star per hidden digit */
export function maskPhone(phone: string): string {
  const digits = phone.replace(/[\s.-]/g, '');
  if (digits.length < 6) return maskText(digits);
  return `${digits.slice(0, 2)}${'*'.repeat(digits.length - 4)}${digits.slice(-2)}`;
}

/** any other identifier (a username): the first two characters */
export function maskText(text: string): string {
  const value = text.trim();
  if (!value) return '';
  return `${value.slice(0, keep(value))}${HIDDEN}`;
}

const PHONE = /^\+?\d[\d\s.-]{7,}$/;

/** Email, phone or username, whichever the value looks like. */
export function maskIdentifier(value: string | null | undefined): string {
  const text = (value || '').trim();
  if (!text) return '';
  if (text.indexOf('@') >= 0) return maskEmail(text);
  if (PHONE.test(text)) return maskPhone(text);
  return maskText(text);
}

/** A vendor, profile or teacher id outside "Chi tiết kỹ thuật": enough to match, not to copy. */
export function maskId(id: string | number | null | undefined): string {
  const text = id === null || id === undefined ? '' : String(id).trim();
  if (!text) return '';
  return `${text.slice(0, 4)}****`;
}

interface NamedAccount {
  teacherName?: string | null;
  user?: { username?: string; email?: string } | null;
}

/** The teacher's name from QLT; the masked login identifier when the name is unknown. */
export function teacherDisplayName(account: NamedAccount, fallback = 'thầy/cô'): string {
  const name = (account.teacherName || '').trim();
  if (name) return name;
  const user = account.user || null;
  return maskIdentifier(user ? user.username || user.email : '') || fallback;
}
